// extracted by mini-css-extract-plugin
module.exports = {"bp-tablet-small-viewport":"(min-width: 768px)","results":"search-results_results__SkkHh","shim":"search-results_shim__bL1_r","divided":"search-results_divided__U8FBE"};